import {
    EFeedbackCategory,
    HP_USER_ACCOUNT_TYPE_TAG_DOMAIN,
    HP_USER_ACCOUNT_TYPE_TAG_EDU,
    HP_USER_ACCOUNT_TYPE_TAG_PERSONAL,
    HP_USER_PLAN_ENTERPRISE,
    HP_USER_PLAN_FREE,
    HP_USER_PLAN_OLD,
    HP_USER_PLAN_PRO,
    HP_USER_PLAN_PREMIUM,
    USER_DOMAIN_ACCOUNT_TYPE,
    USER_EDU_ACCOUNT_TYPE,
    USER_PERSONAL_ACCOUNT_TYPE, HP_MICROSOFT_TAG, HP_USER_PLAN_ESSENTIAL,
} from '../constants';
import { IBackboneUser, IKanbanchiApp, IPaymentData } from '../../../../../types/backbone';
import { PaypalHelper } from './../../../../../helper/paypal_helper.js';
import { root } from '../../../../../store/constants';
import { IAuthUser } from '../../../../../store/model/authUser/types';
import { getAuthUser } from '../../../../../store/model/authUser/selectors/getAuthUser';
import { IApplicationState } from '../../../../../types/types';
import {isMicrosoftAccount} from 'app/store/model/authUser/selectors/isMicrosoftAccount';

const getPlanTag = (user: IAuthUser): Array<string> => {
    const paymentData = <IPaymentData>PaypalHelper.paymentData();
    const plansTags = [];

    if (paymentData.subscriptionEssential || user.domainWideEssential) {
        plansTags.push(HP_USER_PLAN_ESSENTIAL);
    }
    if (paymentData.subscriptionPremium || user.domainWidePremium) {
        plansTags.push(HP_USER_PLAN_PREMIUM);
    }
    if (paymentData.subscriptionProfessional || user.domainWideProfessional) {
        plansTags.push(HP_USER_PLAN_PRO);
    }
    if (paymentData.subscriptionEnterprise || user.domainWideEnterprise) {
        plansTags.push(HP_USER_PLAN_ENTERPRISE);
    }
    if (paymentData.subscriptionOld) {
        plansTags.push(HP_USER_PLAN_OLD);
    }
    if (plansTags.length === 0) {
        plansTags.push(HP_USER_PLAN_FREE);
    }
    return plansTags;
};

const getTypeTag = (user: IAuthUser): string => {
    const userType = user.accountType;
    switch (userType) {
        case USER_DOMAIN_ACCOUNT_TYPE:
            return HP_USER_ACCOUNT_TYPE_TAG_DOMAIN;
        case USER_EDU_ACCOUNT_TYPE:
            return HP_USER_ACCOUNT_TYPE_TAG_EDU;
        case USER_PERSONAL_ACCOUNT_TYPE:
            return HP_USER_ACCOUNT_TYPE_TAG_PERSONAL;
    }
    return 'undefinedTypeTag';
};

export const getTicketTags = (
    state: IApplicationState,
    category: EFeedbackCategory
): Array<string> => {
    try {
        const user = getAuthUser(state);

        const typeTag = getTypeTag(user);
        const plansTags = getPlanTag(user);
        const timeZoneTag = user.timezone;
        let result = [typeTag, ...plansTags, timeZoneTag];

        const isMicrosoftUser = isMicrosoftAccount(state);
        if(isMicrosoftUser) {
            result.push(HP_MICROSOFT_TAG);
        }
        if (category !== EFeedbackCategory.DEFAULT)  {
            result.push(category);
        }
        return result;
    } catch (e) {
        return ['error'];
    }
};
